import React, { useEffect } from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import CustomTable from '../../components/table/Table';
import { useDispatch, useSelector } from "react-redux";
import BasicTabs from '../../components/tabs/Tabs2';
import { Link } from 'react-router-dom';
import { getaccessory, getproduct, getspare} from '../../slices/product';
import { getpurchase } from '../../slices/purchase';
import Popup from '../../components/popup/Popup';

const Purchases = ({setLoader, show}) => {

  const [value, setValue] = React.useState(0);

  const [open, setOpen] = React.useState(false);
  const [modalte, setModalte] = React.useState(null);

  const {purchases: vehicleApiData} = useSelector((state) => state.purchase) || [];

  const {purchases: spareApiData} = useSelector((state) => state.purchase) || [];

  const {purchases: accessoriesApiData} = useSelector((state) => state.purchase) || [];

  const dispatch = useDispatch();

  const {message: message} = useSelector((state) => state.purchase);

  console.log(message);

  useEffect(()=>{
    if(message){
          setOpen(true);
          setModalte(message);
    }
  },[message]);

  useEffect(()=>{
    setLoader(true)
      dispatch(getpurchase())
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])

  return (
    <div className='content' style={{marginLeft: show ? '220px' : '10px'}}>
          <Popup open={open} modalte={modalte} setOpen={setOpen}/>
      <Box>
        <Grid container sx={{ paddingBottom: 2, alignItems:'center' }}>
          <Grid item xs={6} sx={{paddingTop: 0}}>
            <Typography variant='h5' sx={{fontWeight:'bold'}}>
             My Purchases
            </Typography>
          </Grid>
          <Grid item xs={6} sx={{textAlign: 'end', paddingTop: 0}}>
          <Box sx={{display:'flex', justifyContent:'end', alignItems:'center'}}>
          <Link to='/purchase/new'>
          <Button variant='contained' size='large'>+ New Purchases</Button>
          </Link>
          </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <BasicTabs vehicleApiData={vehicleApiData} spareApiData={spareApiData} accessoriesApiData={accessoriesApiData} value={value} setValue={setValue}/>
      </Box>
    </div>
  );
}

export default Purchases;